import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function NotreHistoire() {
  const { t } = useTranslation('apropos');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="histoire" className="bg-white py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl">
            {t('histoire_h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className={`space-y-5 transition-all duration-1000 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}>
            <p className="text-slate-primary/70 text-sm md:text-base leading-relaxed">{t('histoire_p1')}</p>
            <p className="text-slate-primary/70 text-sm md:text-base leading-relaxed">{t('histoire_p2')}</p>
            <p className="text-slate-primary/70 text-sm md:text-base leading-relaxed">{t('histoire_p3')}</p>
          </div>

          <div className={`transition-all duration-1000 delay-300 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}>
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Professional roofing contractor team working together on residential roof in Quebec, autumn season, multiple workers in safety gear installing shingles, suburban neighborhood background with colorful trees, authentic documentary photography style, warm natural tones, no text visible, landscape composition"
                alt="Réseau de couvreurs partenaires certifiés RBQ Couvreur-Lévis.com à l'oeuvre sur un chantier"
                className="w-full h-80 md:h-96 object-cover object-top rounded-xl"
                loading="lazy"
                width="800"
                height="600"
                width="800"
                height="600"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}